/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';
import { RequestBuilder } from '../request-builder';

import { DbTestReq } from '../models/db-test-req';
import { HttpTestReq } from '../models/http-test-req';

@Injectable({ providedIn: 'root' })
export class ServerService extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `apiServerReloadConfsGet()` */
  static readonly ApiServerReloadConfsGetPath = '/api/server/reload-confs';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiServerReloadConfsGet()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiServerReloadConfsGet$Response(
    params?: {
      secret?: string;
    },
    context?: HttpContext
  ): Observable<StrictHttpResponse<boolean>> {
    const rb = new RequestBuilder(this.rootUrl, ServerService.ApiServerReloadConfsGetPath, 'get');
    if (params) {
      rb.query('secret', params.secret, {});
    }

    return this.http.request(
      rb.build({ responseType: 'json', accept: 'application/json', context })
    ).pipe(
      filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return (r as HttpResponse<any>).clone({ body: String((r as HttpResponse<any>).body) === 'true' }) as StrictHttpResponse<boolean>;
      })
    );
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiServerReloadConfsGet$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiServerReloadConfsGet(
    params?: {
      secret?: string;
    },
    context?: HttpContext
  ): Observable<boolean> {
    return this.apiServerReloadConfsGet$Response(params, context).pipe(
      map((r: StrictHttpResponse<boolean>): boolean => r.body)
    );
  }

  /** Path part for operation `apiServerReloadDefaultEmailTemplatesGet()` */
  static readonly ApiServerReloadDefaultEmailTemplatesGetPath = '/api/server/reload-default-email-templates';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiServerReloadDefaultEmailTemplatesGet()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiServerReloadDefaultEmailTemplatesGet$Response(
    params?: {
      secret?: string;
    },
    context?: HttpContext
  ): Observable<StrictHttpResponse<boolean>> {
    const rb = new RequestBuilder(this.rootUrl, ServerService.ApiServerReloadDefaultEmailTemplatesGetPath, 'get');
    if (params) {
      rb.query('secret', params.secret, {});
    }

    return this.http.request(
      rb.build({ responseType: 'json', accept: 'application/json', context })
    ).pipe(
      filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return (r as HttpResponse<any>).clone({ body: String((r as HttpResponse<any>).body) === 'true' }) as StrictHttpResponse<boolean>;
      })
    );
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiServerReloadDefaultEmailTemplatesGet$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiServerReloadDefaultEmailTemplatesGet(
    params?: {
      secret?: string;
    },
    context?: HttpContext
  ): Observable<boolean> {
    return this.apiServerReloadDefaultEmailTemplatesGet$Response(params, context).pipe(
      map((r: StrictHttpResponse<boolean>): boolean => r.body)
    );
  }

  /** Path part for operation `apiServerCacheClearGet()` */
  static readonly ApiServerCacheClearGetPath = '/api/server/cache-clear';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiServerCacheClearGet()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiServerCacheClearGet$Response(
    params?: {
      secret?: string;
    },
    context?: HttpContext
  ): Observable<StrictHttpResponse<string>> {
    const rb = new RequestBuilder(this.rootUrl, ServerService.ApiServerCacheClearGetPath, 'get');
    if (params) {
      rb.query('secret', params.secret, {});
    }

    return this.http.request(
      rb.build({ responseType: 'json', accept: 'application/json', context })
    ).pipe(
      filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<string>;
      })
    );
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiServerCacheClearGet$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiServerCacheClearGet(
    params?: {
      secret?: string;
    },
    context?: HttpContext
  ): Observable<string> {
    return this.apiServerCacheClearGet$Response(params, context).pipe(
      map((r: StrictHttpResponse<string>): string => r.body)
    );
  }

  /** Path part for operation `apiServerExpireTagGet()` */
  static readonly ApiServerExpireTagGetPath = '/api/server/ExpireTag';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiServerExpireTagGet()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiServerExpireTagGet$Response(
    params?: {
      secret?: string;
    },
    context?: HttpContext
  ): Observable<StrictHttpResponse<void>> {
    const rb = new RequestBuilder(this.rootUrl, ServerService.ApiServerExpireTagGetPath, 'get');
    if (params) {
      rb.query('secret', params.secret, {});
    }

    return this.http.request(
      rb.build({ responseType: 'text', accept: '*/*', context })
    ).pipe(
      filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return (r as HttpResponse<any>).clone({ body: undefined }) as StrictHttpResponse<void>;
      })
    );
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiServerExpireTagGet$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiServerExpireTagGet(
    params?: {
      secret?: string;
    },
    context?: HttpContext
  ): Observable<void> {
    return this.apiServerExpireTagGet$Response(params, context).pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

  /** Path part for operation `apiServerDbTestPost()` */
  static readonly ApiServerDbTestPostPath = '/api/server/db-test';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiServerDbTestPost()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  apiServerDbTestPost$Response(
    params?: {
      body?: DbTestReq
    },
    context?: HttpContext
  ): Observable<StrictHttpResponse<string>> {
    const rb = new RequestBuilder(this.rootUrl, ServerService.ApiServerDbTestPostPath, 'post');
    if (params) {
      rb.body(params.body, 'application/json');
    }

    return this.http.request(
      rb.build({ responseType: 'json', accept: 'application/json', context })
    ).pipe(
      filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<string>;
      })
    );
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiServerDbTestPost$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  apiServerDbTestPost(
    params?: {
      body?: DbTestReq
    },
    context?: HttpContext
  ): Observable<string> {
    return this.apiServerDbTestPost$Response(params, context).pipe(
      map((r: StrictHttpResponse<string>): string => r.body)
    );
  }

  /** Path part for operation `apiServerHttpTestPost()` */
  static readonly ApiServerHttpTestPostPath = '/api/server/http-test';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiServerHttpTestPost()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  apiServerHttpTestPost$Response(
    params?: {
      body?: HttpTestReq
    },
    context?: HttpContext
  ): Observable<StrictHttpResponse<string>> {
    const rb = new RequestBuilder(this.rootUrl, ServerService.ApiServerHttpTestPostPath, 'post');
    if (params) {
      rb.body(params.body, 'application/json');
    }

    return this.http.request(
      rb.build({ responseType: 'json', accept: 'application/json', context })
    ).pipe(
      filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<string>;
      })
    );
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiServerHttpTestPost$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  apiServerHttpTestPost(
    params?: {
      body?: HttpTestReq
    },
    context?: HttpContext
  ): Observable<string> {
    return this.apiServerHttpTestPost$Response(params, context).pipe(
      map((r: StrictHttpResponse<string>): string => r.body)
    );
  }

}
